import { Component, Input, OnInit } from '@angular/core';
import { AudioService } from '../../../services/audio.service';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
	selector: 'app-audio-button',
	standalone: true,
	imports: [NzIconModule],
	templateUrl: './audio-button.component.html',
	styleUrl: './audio-button.component.scss',
})
export class AudioButtonComponent implements OnInit {
	@Input('audioUrl') public audioUrl: any;
	@Input('blob') public blob: any;

	constructor(public audioService: AudioService) {}

	ngOnInit(): void {}

	public playAudio() {
		if (this.blob) {
			this.audioService.playBlob(this.blob);
		}
		if (this.audioUrl) {
			this.audioService.play(this.audioUrl);
		}
	}
}
